import { ModelResource } from './resource';
import { Claim, DeductionReason, Partner } from '../models';
import { downloadBlob } from '@ui/utils/utils';

interface ExportFilers {
  customer?: Partner;
  reason?: DeductionReason[];
  created_at_gte?: string;
  created_at_lte?: string;
  matched?: boolean;
  approved?: boolean;
}

export class Claims extends ModelResource<Claim> {
  model = Claim;

  resourcePath = 'v1/deductions/claims';

  async approveAll(id: string, claim: Claim) {
    const response = await this.api.patch(this.path(id), {
      data: { approval_status: 'approved' },
    });

    if (claim) {
      claim.updateFromJson(response.data);
    } else {
      claim = Claim.fromJson(response.data);
    }

    return claim;
  }

  async assignDeduction(id: string, deductionId, claim: Claim) {
    const response = await this.api.patch(this.path(id), {
      data: { deduction_id: deductionId },
    });

    if (claim) {
      claim.updateFromJson(response.data);
    } else {
      claim = Claim.fromJson(response.data);
    }

    return claim;
  }

  async updateTotal(id: string, amount, claim: Claim) {
    const response = await this.api.patch(this.path(id), {
      data: { amount },
    });

    if (claim) {
      claim.updateFromJson(response.data);
    } else {
      claim = Claim.fromJson(response.data);
    }

    return claim;
  }

  async updateReason(id: string, reason_id, claim: Claim) {
    const response = await this.api.patch(this.path(id), {
      data: { reason_id },
    });

    if (claim) {
      claim.updateFromJson(response.data);
    } else {
      claim = Claim.fromJson(response.data);
    }

    return claim;
  }

  async export(params: ExportFilers) {
    let url = 'v1/deductions/claims-export';

    if (Object.keys(params)?.length) url += '?';

    if (params?.customer?.id) url += `customer[]=${params?.customer?.id}&`;
    if (params?.created_at_lte) url += `created_at_lte=${params?.created_at_lte}&`;
    if (params?.created_at_gte) url += `created_at_gte=${params?.created_at_gte}&`;

    const response = await this.api.get(url, {
      responseType: 'blob',
    });

    return downloadBlob(response.data, 'claims-export.csv', 'text/csv');
  }

  async update(id: string, data, claim: Claim) {
    const response = await this.api.patch(this.path(id), {
      data,
    });

    if (claim) {
      claim.updateFromJson(response.data);
    } else {
      claim = Claim.fromJson(response.data);
    }

    return claim;
  }
}
